import React from "react";
import CommonPieChart from "../../../../components/common/Chart/CommonPieChart";
import { FormSelect } from "../../../../components/common/Select/FormSelect";
import { useTranslation } from "react-i18next";

const TakeResultStep1 = ({
  activeTab,
  selectedLocation,
  handleTabChange,
  handleLocationSelect,
  chartData,
  questLocations,
  segmentationResults,
}) => {
  const { t } = useTranslation();

  const tabOptions = segmentationResults.map((seg) => ({
    label: seg.segmentation,
    value: seg.field,
  }));

  const activeSegmentation = segmentationResults.find(
    (seg) => seg.field === activeTab
  );
  const chartTitle = activeSegmentation
    ? `${activeSegmentation.segmentation} ${t("base.statistics")}`
    : t("base.statistics");

  const hasDataToDisplay = chartData.data.some((value) => value > 0);

  return (
    <section className="flex flex-col items-center">
      <div className="mt-3 w-full">
        <FormSelect
          value={selectedLocation}
          onChange={(e) => handleLocationSelect(e.target.value)}
          defaultValue={t("base.allLocations")}
          options={[
            { value: "", label: t("base.allLocations") },
            ...(questLocations || []).map((location) => ({
              value: location?.location.id,
              label: location?.location.name ?? location?.location.address,
            })),
          ]}
          className="mt-0 bg-stone-100 text-blue-600 text-sm font-medium"
        />
      </div>
      <div className="mt-3 w-full">
        <FormSelect
          value={activeTab}
          onChange={(e) => handleTabChange(e.target.value)}
          options={tabOptions}
          className="mt-0 bg-stone-100 text-blue-600 text-sm font-medium"
        />
      </div>
      <article className="p-2 bg-white rounded-xl text-zinc-800 w-full mt-3">
        <div className="w-full  mt-3">
          {hasDataToDisplay ? (
            <CommonPieChart
              data={chartData.data}
              labels={chartData.labels}
              colors={chartData.colors}
              title={chartTitle}
              width="100%"
            />
          ) : (
            <div className="flex justify-center items-center h-full">
              <p className="text-zinc-400">{t("base.noDataAvailable")}</p>
            </div>
          )}
        </div>
      </article>
    </section>
  );
};

export default TakeResultStep1;
